import { K as l } from "./keys-5bn9IqQ3.js";
import { m as d } from "./lifecycle-decorators-Cg3csm0R.js";
var i = Object.getOwnPropertyDescriptor, w = (c, n, e, r) => {
  for (var s = r > 1 ? void 0 : r ? i(n, e) : n, t = c.length - 1, a; t >= 0; t--)
    (a = c[t]) && (s = a(s) || s);
  return s;
};
function A(c) {
  let n = class extends c {
    /**
     * Keyboard event handler for arrow control. Uses the element that we are currently
     * focused on to find order which removes any complexity that comes from tracking
     * the current index.
     *
     * To use the mixin, attach this event listener to each of the events to be
     * controlled with arrow control, then pass an array of those elements as arrowControlElements
     *
     * @param event
     * @param arrowControlElements elements to move focus between, in order
     * @param layoutDirection 'horizontal', 'vertical', or 'any' depending on which arrow keys should be used
     * @param focusCallback callback to when an element is focused. Allows element to autoselect or defer focus to a child
     */
    handleArrowControlKeydown(e, r, s, t) {
      let a = !1;
      if (e && e.isTrusted) {
        const o = n.calculateArrowIncrement(
          e,
          s
        );
        if (o != 0) {
          const u = r.indexOf(
            e.currentTarget
          );
          if (u != -1) {
            const f = n.ensureFocusIndexInRange(
              u + o,
              r.length
            );
            t.call(this, r[f]), a = !0;
          }
        }
      }
      return a;
    }
    /**
     * Calculates the index increment based on the input keys.
     * @param event
     * @param layoutDirection
     * @returns
     */
    static calculateArrowIncrement(e, r) {
      return e.key === l.LEFT && (r === "horizontal" || r === "any") || e.key === l.UP && (r === "vertical" || r === "any") ? -1 : e.key === l.RIGHT && (r === "horizontal" || r === "any") || e.key === l.DOWN && (r === "vertical" || r === "any") ? 1 : 0;
    }
    /**
     * Wraps the focus index around the ends of the array
     * @param focusIndex
     * @param numberOfElements
     * @returns
     */
    static ensureFocusIndexInRange(e, r) {
      return e < 0 ? r - 1 : e >= r ? 0 : e;
    }
  };
  return n = w([
    d("ArrowControl")
  ], n), n;
}
export {
  A
};
